import {
  Stack,
  Text,
  Group,
  Badge,
  Card,
  Space,
  Alert,
  ScrollArea,
} from '@mantine/core';
import React from 'react';
import { AlertCircle } from 'tabler-icons-react';
import { CheckIcon } from '../../constants/icon';
import { FinishTabMappingContainer } from './ModalImportExcelCSS';

export default function FinishTabMapping({ importResult }) {
  const isSuccess = importResult?.success ?? false;
  const inserted = importResult?.inserted ?? 0;
  const skipped = importResult?.skipped ?? 0;
  const errors = importResult?.errors ?? [];
  const jobId = importResult?.jobId ?? '';

  return (
    <FinishTabMappingContainer>
      <Stack spacing="xl" style={{ maxWidth: 600, width: '100%' }}>
        {/* Icon and main message */}
        <Stack align="center" spacing="md">
          <div style={{ width: 60, height: 60 }}>
            {isSuccess ? <CheckIcon /> : <AlertCircle />}
          </div>
          <Text weight={600} size="xl" align="center">
            {isSuccess
              ? 'Import Completed Successfully!'
              : 'Import Completed with Issues'}
          </Text>
        </Stack>

        {/* Summary Card */}
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Stack spacing="md">
            <Text weight={500} size="lg" color="dark">
              Import Summary
            </Text>

            <Group position="apart">
              <Text size="sm" color="dimmed">
                Records Inserted:
              </Text>
              <Badge color="green" variant="light" size="lg">
                {inserted}
              </Badge>
            </Group>

            <Group position="apart">
              <Text size="sm" color="dimmed">
                Records Skipped:
              </Text>
              <Badge
                color={skipped > 0 ? 'yellow' : 'gray'}
                variant="light"
                size="lg"
              >
                {skipped}
              </Badge>
            </Group>

            <Group position="apart">
              <Text size="sm" color="dimmed">
                Status:
              </Text>
              <Badge
                color={isSuccess ? 'green' : 'red'}
                variant="light"
                size="lg"
              >
                {isSuccess ? 'Success' : 'Failed'}
              </Badge>
            </Group>

            {jobId && (
              <Group position="apart">
                <Text size="sm" color="dimmed">
                  Job ID:
                </Text>
                <Text size="sm" family="monospace" color="blue">
                  {jobId.substring(0, 8)}...
                </Text>
              </Group>
            )}
          </Stack>
        </Card>

        {/* Errors section */}
        {errors && errors.length > 0 && (
          <>
            <Space h="sm" />
            <Alert
              icon={<AlertCircle size={16} />}
              title={`Warnings (${errors.length})`}
              color="red"
            >
              <ScrollArea
                style={{ height: 150 }}
                scrollbarSize={8}
                offsetScrollbars
              >
                <div style={{ paddingRight: 12 }}>
                  {errors.map((error, index) => (
                    <Text key={index} size="sm" style={{ marginBottom: 8 }}>
                      • {error}
                    </Text>
                  ))}
                </div>
              </ScrollArea>
            </Alert>
          </>
        )}

        {/* Additional info */}
        {isSuccess && inserted > 0 && (
          <Text size="sm" color="dimmed" align="center">
            Your data has been successfully imported and is now available in the
            system.
          </Text>
        )}
      </Stack>
    </FinishTabMappingContainer>
  );
}
